export { default } from './FormPageTouristAgency.vue'
